import { combineReducers } from 'redux';

import template from './template';
import cancelTransaction from './cancelTransaction';
import transactionHelpText from './transactionHelpText';
import errorBlockTransaction from './errorBlockTransaction';
import limitCheck from './limitCheck';

export default combineReducers({
  template,
  cancelTransaction,
  transactionHelpText,
  errorBlockTransaction,
  limitCheck,
});



// WEBPACK FOOTER //
// ./components/transaction/src/reducer/modal/index.js